// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2MxBZ","upload":"Small_upload__2ILlJ","imageWrap":"Small_imageWrap__262H3","removeBtn":"Small_removeBtn__MVO-E"};